// extracted by mini-css-extract-plugin
export default {"container":"yG-z","modal":"zG-z","dimensions":"AG-z","brandName":"BG-z","productName":"CG-z","recipientEmail":"DG-z","recommendedFit":"EG-z","hiddenField":"FG-z"};